import config from "../config/config.json";
import saveAs from "file-saver";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const usersOnboardingService = {
  updateUserPermission,
  getStudyStatus,
  getUserStudyStatus,
  assignGroupsofManagement,
  getSeparateuserData,
  getSeparateActiveApprovedUser,
  updateUserStatusOnBoardingToActive,
  getClientData,
  getSingleUserClient,
  getUserDataByID,
  userRegistration,
  createUserByUser,
  getAssignedClient,
  getCountries,
  getStates,
  getCities,
  getDesignation,
  deleteDesignation,
  createDesignationName,
  updateDesignationName,
  getManagentList,
  changeUserManagementStatus,
  assignStudyManagementGroupToUser,
  assignCTMSManagementGroupToUser,
  unAassignStudyManagementGroupToUser,
  changeUserStatus,
  getSeparateRoleStatusCount,
  countOfArchivedRequest,
  countOfRequestWithinDays,
  assignClientofUser,
  exportuserDataInCSVFormat,
  exportuserDataInExcelFormat,
  exportActiveuserDataInCSVFormat,
  exportActiveuserDataInExcelFormat,
  exportRequestuserDataInCSVFormat,
  exportRequestuserDataInExcelFormat,
  exportArchiveRequestuserDataInCSVFormat,
  exportArchiveRequestuserDataInExcelFormat,
  getUsersUpdateHistoryData,
  assignDesignation,
  getAssignedActiveApprovedClients,
  getProjectIdBasedonClient,
  getStudyIdBasedonClient,
  getProjectIdBasedonStudyId,
  getStudyRoleBasedonStudyId,
  findStudyLabel,
  getUserActivities,
  getStudyActivitiesByModule,
  filterRecentStudyActivityData,
  recentStudyActivityDataForFilter,
  getAssignedAppUser,
  assignETMFManagementGroupToUser,
  assignCDISCManagementGroupToUser,
  assignIWRSManagementGroupToUser,
  assignRBQMManagementGroupToUser,
  assignSDMManagementGroupToUser,
  unAassignETMFManagementGroupToUser,
  unAassignCDISCManagementGroupToUser,
  unAassignCTMSManagementGroupToUser,
  unAassignIWRSManagementGroupToUser,
  unAassignRBQMManagementGroupToUser,
  unAassignSDMManagementGroupToUser,
};
async function updateUserPermission(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/updateUserPermission`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignGroupsofManagement(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignGroupsofManagement`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getSeparateuserData(status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSeparateUsersByStatus/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getUserActivities() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserActivities`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAssignedAppUser(id, status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedAppUser/${id}/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getSeparateActiveApprovedUser() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSeparateActiveApprovedUser`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function getStudyStatus() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyStatus`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function getUserStudyStatus() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserStudyStatus`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}


async function getUserDataByID(userID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/${userID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function getClientData(userID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserClients/${userID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAssignedClient(userID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedClient/${userID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function assignClientofUser(datas, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/assignClients`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  await handleResponse(data);
}
async function deleteDesignation(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteDesignation/${id}`,
    headersWithAuthWithoutBody("DELETE", headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function getDesignation() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDesignation`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function createDesignationName(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createDesignation`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function updateDesignationName(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateDesignation`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function getSingleUserClient(userID, clientID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUserClient/user/${userID}/client/${clientID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function userRegistration(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}userRegistration`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getSeparateRoleStatusCount(permission) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSeparateRoleStatusCount/${permission}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function countOfArchivedRequest() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}countOfRequestBeforeDays`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function countOfRequestWithinDays() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}countOfRequestWithinDays`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function createUserByUser(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}request/userRegistration`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  let getResponse = await handleResponse(data);
  if (getResponse === true) {
    history(`/newuser`);
  }
  return data;
}

async function assignDesignation(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignDesignation`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function changeUserStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/updateStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}
async function updateUserStatusOnBoardingToActive(userData, history) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}user/updateUserStatusOnBoardingToActive`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
}


async function getUsersUpdateHistoryData(userId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUsersUpdateHistoryData/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function changeUserManagementStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}accessManagement/assignGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignStudyManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignStudyManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignCTMSManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignCTMSManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignETMFManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignETMFManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignCDISCManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignCDISCManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignIWRSManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignIWRSManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignRBQMManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignRBQMManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function assignSDMManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignSDMManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignStudyManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignStudyManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignETMFManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignETMFManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignCDISCManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignCDISCManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignIWRSManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignIWRSManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignRBQMManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignRBQMManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignSDMManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignSDMManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function unAassignCTMSManagementGroupToUser(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unAassignCTMSManagementGroupToUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getManagentList() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}accessManagement/getGroups`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function exportuserDataInCSVFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportAllUserAndClientDataEXCEL/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportuserDataInExcelFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportAllUserAndClientDataEXCEL/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportActiveuserDataInCSVFormat() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportAllActiveApprovedUserAndClientInCSV/user`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportActiveuserDataInExcelFormat() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportAllActiveApprovedUserAndClientInEXCEL/user`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportRequestuserDataInCSVFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportRequestUserAndClientDataCSV/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportRequestuserDataInExcelFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportRequestUserAndClientDataExcel/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportArchiveRequestuserDataInCSVFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportArchiveRequestUserAndClientDataCSV/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function exportArchiveRequestuserDataInExcelFormat(Status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}exportArchiveRequestUserAndClientDataExcel/user/${Status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  let url = config.BACKEND_URL + data?.data;
  saveAs(url, data?.data);
}
async function getCountries() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCountries`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function getStates(CountryID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStates/${CountryID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
async function getCities(StateID) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getCities/${StateID}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAssignedActiveApprovedClients() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedActiveApprovedClients`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectIdBasedonClient(clientId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectIdBasedonClient/${clientId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyIdBasedonClient(projectId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyIdBasedonClient/${projectId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectIdBasedonStudyId(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectIdBasedonStudyId/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyRoleBasedonStudyId(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyRoleBasedonStudyId/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function findStudyLabel(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}findStudyLabel/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyActivitiesByModule(uniqueId, studyId, category, studyMode) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyActivitiesByModule/${uniqueId}/${studyId}/${category}/${studyMode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function recentStudyActivityDataForFilter(studyId, studyMode) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}recentStudyActivityDataForFilter/${studyId}/${studyMode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function filterRecentStudyActivityData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}filterRecentStudyActivityData`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}